export const types = {
  COPY_ANALYTICS_DRAWER_OPEN:
    'drawers/copyAnalyticsDrawer/COPY_ANALYTICS_DRAWER_OPEN',
  COPY_ANALYTICS_DRAWER_CLOSE:
    'drawers/copyAnalyticsDrawer/COPY_ANALYTICS_DRAWER_CLOSE',
};

export const copyAnalyticsDrawer = {
  open: () => ({
    type: types.COPY_ANALYTICS_DRAWER_OPEN,
  }),
  close: () => ({
    type: types.COPY_ANALYTICS_DRAWER_CLOSE,
  }),
};
